export default {
    path: 'logManagement',
    name: 'logManagementForm',
    component() {
        return import('@/components/logManagement/LogManagementForm.vue');
    },
    children: [
        {
            path: '',
            name: 'LogManagement',
            component() {
                return import('@/components/logManagement/LogManagement.vue');
            }
        },
    ],
}